module.exports = __webpack_public_path__ + "static/media/pic_winie2_01.669398eb.png";